module.exports = __webpack_public_path__ + "b9981e90254d1c970b8fbe4e1745eac0.png";